export default "{\n  me {\nname\n       }\n}\n"